import { Button, Input, Modal, Select } from 'antd';
import { useEffect, useState, useCallback } from "react";
import {
    useParams
} from 'react-router-dom';

import { Card, CardBody, CardTitle, Container } from 'reactstrap';
import { default as FormService, default as service } from '../../redux/services/forms';
const { Option } = Select


// ---- Fixed config -----------------------------------------------------
// Location Key is intentionally hardcoded (not user-entered) per request.
// Change these two constants if you ever point this at a different
// Firebase project or location.
const FIREBASE_URL = 'https://stpcext-5dc62-default-rtdb.firebaseio.com';

const ONLINE_WINDOW_MS = 15000; // a display counts as "online" if seen in the last 15s

function basePath() {
  return `${FIREBASE_URL}/locations/${encodeURIComponent(localStorage.getItem('locationCode'))}`;
}


const DisplayManager = (props) => {
    const { form_id } = useParams();
    const [modalVisible, setModalVisible] = useState(false);

    const [selectedDisplayId, setSelectedDisplayId] = useState('');
    const [displays, setDisplays] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);

    const fetchDisplays = async () => {
        try {
            const res = await fetch(`${basePath()}/displays.json`);
            const data = await res.json();
            if (data && data.error) {
                setDisplays([]);
                return;
            }
            const list = data ? Object.entries(data).map(([id, d]) => ({ id, ...d })) : [];
            setDisplays(list);
        } catch (e) {
            setDisplays([]);
        }
    }


    const loadDisplayAlerts = () => {
        service.getDisplayManager(form_id).then(res => {
            setAlerts(res.data);
        });
    }
    
    useEffect(() => {
        FormService.getFormDetail(form_id).then(res => {
            // setForm(res);
            setPageCount(res.page_count);
        });
        fetchDisplays();
        loadDisplayAlerts();
    }, [form_id]);

    const onCreate = async (e) => {
        e.preventDefault();
        if(selectedDisplayId==null || selectedDisplayId==undefined || selectedDisplayId==""){
            return '';
        }

        if(pageNumber==null || pageNumber==undefined || pageNumber==""){
            return '';
        }

        if(parseInt(pageNumber)<=0){
            return '';
        }

        const selectedDisplay = displays.find((d) => d.id === selectedDisplayId) || null;

        let payload = {
            'form': parseInt(form_id),
            'page_number': pageNumber,
            'display_name': selectedDisplay?.name || selectedDisplayId,
            'display_id': selectedDisplayId,
            'location_code': localStorage.getItem('locationCode')
        };

        var resp = await service.createDisplayManager(payload);
        
        console.log('resp > ', resp);

        setModalVisible(false);
        loadDisplayAlerts();
    };
 

    const onDelete = (data) => {
        if (window.confirm('Are you sure want to delete this display?')) {
            service.deleteDisplayManager(data.id).then(res => {
                loadDisplayAlerts();
            });
        }
    }

  

    return (
        <Container fluid={false} style={{ marginTop: 50 }}>

            <Modal title={"Create Notification"} visible={modalVisible} destroyOnClose={true} onCancel={(e) => {
                setModalVisible(false);
            }} onOk={onCreate}>
                <div>
                    <b>Alert Name</b>
                    <Select style={{width: '100%'}} 
                    value={selectedDisplayId}
                    onChange={(value) =>{
                        setSelectedDisplayId(value);
                    }}
                    >
                        {
                            displays.map((d) => (
                                <Option key={d.id} value={d.id}>
                                    {d.name || d.id}
                                    {d.lastSeen && Date.now() - d.lastSeen < ONLINE_WINDOW_MS ? ' · online' : ' · offline'}
                                </Option>
                            ))
                        }
            
                    </Select>
                    <br />
                    <br />
                    <b>Page Number</b>
                    
                    <Select style={{width: '100%'}} onChange={(value) => {
                        setPageNumber(value);
                    }} value={pageNumber}>
                        {Array.from({ length: pageCount }, (_, index) => (
                            <Option key={index + 1} value={index + 1}>
                                Page {index + 1}
                            </Option>
                        ))}
                    </Select>

                </div>
            </Modal>

            <Card style={{ padding: 10 }}>
                <CardTitle>
                    <h5>Display Managers</h5>
                    <Button type="primary" style={{ position: 'absolute', top: 10, right: 10 }} onClick={() => { setModalVisible(true); }} >Add New</Button>
                </CardTitle>
                <CardBody>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>Display</th>
                                <th>Page Number</th>
                                <th>Location Code</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                alerts?.results?.map((element, index) => {
                                    return (
                                        <tr key={`tbl_indx_${index}`}>
                                            <td>{element?.display_name}</td>
                                            <td>{element?.page_number}</td>
                                            <td>{element?.location_code}</td>
                                            <td>
                                                <Button danger type='primary' onClick={() => {
                                                    onDelete(element);
                                                }}>Delete</Button>
                                            </td>
                                        </tr>
                                    )
                                }
                                )
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card>
        </Container>
    );

}


export default DisplayManager;
